import React from 'react';

import type { EditorNextProps } from '@atlaskit/editor-core/composable-editor';
import { fg } from '@atlaskit/platform-feature-flags';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import { ComposableEditorWithSkills as ComposableEditorWithSkillsLegacy } from './index';
import type { EditorApiWithTypeAhead } from './index';

const ComposableEditorWithSkillsV2Lazy = React.lazy(
	() =>
		import(
			/* webpackChunkName: "composable-editor-skills-v2" */
			'./ComposableEditorWithSkillsV2'
		).then((mod) => ({ default: mod.ComposableEditorWithSkills })),
);

/**
 * Gated wrapper around ComposableEditorWithSkills.
 *
 * When the `platform_editor_insert_menu_ai` experiment is enabled, lazy-loads
 * the optimised version that renders the editor immediately with a fallback
 * skill chip provider (eliminating the blink when a skill chip is in the
 * defaultValue ADF).
 *
 * When the experiment is off, renders the original legacy component unchanged.
 */
export const ComposableEditorWithSkillsGated = (
	props: EditorNextProps & {
		siteId: string;
		promptHasSkill: boolean;
		isConversationAgentic: boolean;
		enableSkills: boolean;
		editorApi?: EditorApiWithTypeAhead;
	},
): JSX.Element => {
	if (
		expValEquals('platform_editor_insert_menu_ai', 'isEnabled', true) &&
		fg('rovo_chat_enable_skills_ui_m1')
	) {
		return <ComposableEditorWithSkillsV2Lazy {...props} />;
	}

	return <ComposableEditorWithSkillsLegacy {...props} />;
};
